import { PerspectiveFilters, Filter as FilterType } from 'aqTypes';
import { globalFilters as Filters } from 'collections/filters';
import { dynamicFilters as DynamicFilters } from 'filters/dynamicFilters';
import { Filter } from 'models/filter';
import { FilterTypes, isSystemFilter } from '@ardoq/api-types';
import { groupingRuleOperations } from '@ardoq/core';
import { GroupingRule } from '@ardoq/api-types';

type Encodable = { encodeURI: () => string };

const buildModifiersQueryString = (
  attributeFilters: FilterType[],
  tagFilters: FilterType[],
  dateRangeFilters: FilterType[],
  groupBys: GroupingRule[],
  compLabelFilter: FilterType[],
  refLabelFilter: FilterType[],
  compLabelMultiSelectFilter: FilterType[],
  refLabelMultiSelectFilter: FilterType[],
  dynamicFilters: Encodable[],
  systemFilters: FilterType[] = []
): string =>
  [
    ...attributeFilters.map(f => f.encodeURI()),
    ...tagFilters.map(f => f.encodeURI()),
    ...dateRangeFilters.map(f => f.encodeURI()),
    ...groupBys.map(groupingRuleOperations.encodeGroupByToURI),
    ...compLabelFilter.map(f => f.encodeURI()),
    ...refLabelFilter.map(f => f.encodeURI()),
    ...compLabelMultiSelectFilter.map(f => f.encodeURI()),
    ...refLabelMultiSelectFilter.map(f => f.encodeURI()),
    ...dynamicFilters.map(d => d.encodeURI()),
    ...systemFilters.map(d => d.encodeURI()),
  ].join('');

export const getModifiersAsQueryString = (groupBys: GroupingRule[]): string =>
  buildModifiersQueryString(
    Filters.getAttributeFilters(),
    Filters.getTagFilters(),
    Filters.getDateRangeFilters(),
    groupBys,
    Filters.getCompLabelFilter(),
    Filters.getRefLabelFilter(),
    Filters.getCompMultiLabelFilter(),
    Filters.getRefMultiLabelFilter(),
    DynamicFilters.getDynamicFiltersAsEncodables(),
    Filters.getAllFilters().filter(({ attributes }) =>
      isSystemFilter(attributes)
    )
  );

export const getPerspectiveModifiersAsQueryString = (
  filters: PerspectiveFilters,
  groupBys: GroupingRule[]
): string => {
  const [
    attributeFilters,
    tagFilters,
    dateRangeFilters,
    componentLabelFilter,
    referenceLabelFilter,
    systemFilters,
  ] = [
    FilterTypes.ATTRIBUTE,
    FilterTypes.TAG,
    FilterTypes.DATE_RANGE,
    FilterTypes.COMPONENT_LABEL,
    FilterTypes.REFERENCE_LABEL,
    FilterTypes.SYSTEM_FILTER,
  ].map(filterType =>
    filters.advancedFilters
      .filter(({ type }) => type === filterType)
      .map(filterAttributes => new Filter(filterAttributes))
  );
  return buildModifiersQueryString(
    attributeFilters,
    tagFilters,
    dateRangeFilters,
    groupBys,
    componentLabelFilter,
    referenceLabelFilter,
    [],
    Filters.getRefMultiLabelFilter(),
    DynamicFilters.getDynamicFiltersAsEncodables(),
    systemFilters
  );
};
